import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import VideoGuide from "@/pages/VideoGuide";
import { CookieConsent } from "@/components/CookieConsent";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/video-guide" element={<VideoGuide />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  </React.StrictMode>,
);
